import React from 'react';

export const defaultLocale = 'en-US';

export const MarkdownSafeMdxViewerLocaleContext = React.createContext(defaultLocale);
